// extracted by mini-css-extract-plugin
export var body = "_c4-0";
export var sectionHeader = "_c4-4";
export var shortcutColumns = "_c4-2";
export var shortcutList = "_c4-1";
export var shortcutSection = "_c4-3";